export default __webpack_public_path__ + "static/media/brand.a9a5f196.svg";